import { apiRequest, putApiRequest } from './_tools';

export function fetchUnreadNotificationsForUser({ userId, limit }) {
  return apiRequest('/api/notifications?' +
    `userId=${userId}` +
    `&limit=${limit}` +
    '&unread=true')
    .catch(({ error }) => Promise.reject(error));
}

export function markNotificationAsRead(notificationId) {
  return putApiRequest(`/api/notifications/${notificationId}/read`, {});
}



/** WEBPACK FOOTER **
 ** ./js/core/api/notifications.js
 **/